(() => {
  const bundlePaths = new Set([
    '/pages/dein-individuelles-duft-bundle',
    '/pages/bundle-erstellen',
    '/pages/duft-bundle'
  ]);

  const addBundleView = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !bundlePaths.has(url.pathname)) return value;
      if (!url.searchParams.has('view')) url.searchParams.set('view', 'bundle-erstellen');
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return value;
    }
  };

  const rewriteLinks = (root = document) => {
    root.querySelectorAll?.('a[href]').forEach((link) => {
      const next = addBundleView(link.getAttribute('href'));
      if (next && next !== link.getAttribute('href')) link.setAttribute('href', next);
    });
  };

  const initScrollButtons = (root = document) => {
    root.querySelectorAll?.('[data-nishe-scroll-target]').forEach((link) => {
      if (link.dataset.nisheScrollReady === 'true') return;
      link.dataset.nisheScrollReady = 'true';
      link.addEventListener('click', (event) => {
        const target = document.getElementById(link.dataset.nisheScrollTarget || '');
        if (!target) return;
        event.preventDefault();
        target.classList.add('nishe-bundle-anchor-target');
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  };

  const init = (root = document) => {
    rewriteLinks(root);
    initScrollButtons(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:reorder', () => init());
})();
